import {
  Box,
  Button,
  CardMedia,
  Grid,
  Badge,
  IconButton,
  Stack,
  Typography,
  FormControl,
  InputLabel,
  Input,
  InputAdornment,
  Menu,
} from '@mui/material';
import { CommonLayout } from '../commonComponents';
import { SubHeading } from './components';
import SearchSharpIcon from '@mui/icons-material/SearchSharp';
import AddIcon from '@mui/icons-material/Add';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { useHistory } from 'react-router';
import { ChangeEvent, useEffect, useState } from 'react';
import {
  getAllApplications,
  getConsolidatedStampPaperCount,
  getStampPaperCount,
} from '../../redux-store/actions/application';
import { useDispatch, useSelector } from 'react-redux';
import { FilterDropdown, initialFilters } from './filters';
import { Distributor, getDistributorsListForFilters } from '../../redux-store/actions';
import { ApplicationFilterType } from '../../redux-store/types/api-types';
import {
  ApplicationProps,
  StampPapersType,
  stampPaperProp,
} from '../../redux-store/types/api-types';
import { RootStateType } from '../../redux-store/reducers';
import React from 'react';
import { GetAllApplicantionsResponseBody } from '../../redux-store/types/application';
// import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { DISABLE_NEW_APPLICATIONS, USER_ROLES } from '../../utils/constant';
import { useDebounce } from '../../utils/useDebounce';
import DashboardAndApplicationsList from '../dashboard/applicationslist';
import { ListPaginationBar } from '../common/ListPagination';
import { Formik } from 'formik';
import MFCheckbox from '../../lib/formik/Checkbox';
import LiveRegion from '../LiveRegion';
import { useSearchResultsAnnouncement } from '../../hooks/useSearchResultsAnnouncement';
import ApplicationStatusCards, {
  APPLICATION_STATUS_CARDS,
  ApplicationStatusCardKey,
  ApplicationStatusCounts,
  StatusCardConfig,
} from './ApplicationStatusCards';
import { getOnboardingDashboard } from '../../redux-store/actions/application';
import { OnboardingDashboardResponse } from '../../redux-store/types/api-types';

interface Values {
  pan: string;
}
const FilterMenu = (): JSX.Element => {
  const initialValues1: Values = { pan: '' };
  const handleSubmit = (values: Values) => {
    console.log(values);
  };
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <Formik initialValues={initialValues1} onSubmit={handleSubmit}>
      {({ handleSubmit }) => (
        <Box component="form" noValidate onSubmit={handleSubmit}>
          <IconButton
            sx={{ p: 0 }}
            id="filter-button"
            aria-controls="filter-menu"
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}>
            <CardMedia component="img" src="/images/filter-icon.svg" alt="Filter" />
          </IconButton>
          <Menu
            id="filter-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'filter-button',
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            sx={{
              '.MuiPaper-root': { p: 2, pt: 1 },
              '.MuiTypography-root': {
                fontFamily: 'Poppins, sans-serif',
                fontSize: 14,
                '&.MuiTypography-body2': { color: 'primary.main', mb: 1 },
              },
              '.MuiBox-root:not(:last-of-type)': {
                position: 'relative',
                mr: 5,
                '::after': {
                  content: '""',
                  position: 'absolute',
                  top: 10,
                  right: -15,
                  width: '2px',
                  height: '100%',
                  background:
                    'linear-gradient(to bottom, rgba(0, 0, 0, 0.2),rgba(255, 255, 255, 0) )',
                },
              },
            }}>
            <Stack direction="row">
              <Box>
                <Typography variant="body2">Mode of holding</Typography>
                <MFCheckbox name="single" label="Single" />
                <MFCheckbox label="joint" name="Joint" />
              </Box>
              <Box>
                <Typography variant="body2">Status</Typography>
                <MFCheckbox name="Draft" label="Draft" />
                <MFCheckbox name="in-process" label="In Process" />
                <MFCheckbox name="completed" label="Completed" />
              </Box>
              <Box>
                <Typography variant="body2">Distributor Name</Typography>
                <MFCheckbox name="distributor-name1" label="Distributor Name 1" />
                <MFCheckbox name="distributor-name2" label="Distributor Name 2" />
              </Box>
            </Stack>
          </Menu>
        </Box>
      )}
    </Formik>
  );
};

export default function Investors(): JSX.Element {
  const history = useHistory();
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const [applicationsList, setApplicationsList] = useState<ApplicationProps[]>([]);
  const [noOfPages, setNoPages] = useState(1);
  const [totalApplications, setTotalApplications] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [stampCount, setStampCount] = useState<stampPaperProp[]>([]);
  const {
    page,
    search: storeSearch,
    status: storeStatus,
    applicationType: storeApplicationType,
    modeOfHolding: storeModeOfHolding,
    distributorId: storeDistributorId,
    applicationSentBack,
  } = useSelector((store: RootStateType) => store.paramsObj);
  const [currentPage, setPage] = useState(page);
  const [open, setOpen] = useState(false);
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const [filtersAnchorEl, setFiltersAnchorEl] = useState<boolean>(false);
  const [distributors, setDistributors] = useState<Distributor[]>([]);
  const [filters, setFilters] = useState<ApplicationFilterType>(
    initialFilters(
      role,
      applicationSentBack ? storeStatus.replace('draft', 'draft_send_back') : storeStatus,
      storeApplicationType,
      storeModeOfHolding,
      storeDistributorId
    )
  );
  const { applicationType, distributorId, status, modeOfHolding } = filters;
  const [search, setSearch] = useState(storeSearch);
  const debounceSearchString = useDebounce(search, 500);
  const [distributorLoading, setDistributorLoading] = useState(false);
  const [statusCounts, setStatusCounts] = useState<ApplicationStatusCounts>({
    draft: 0,
    pending: 0,
    completed: 0,
    expired: 0,
  });

  const searchResultsMessage = useSearchResultsAnnouncement(
    applicationsList.length,
    isLoading,
    debounceSearchString
  );

  const activeStatusCardKey = ((): ApplicationStatusCardKey | null => {
    const matched = APPLICATION_STATUS_CARDS.find((card) => {
      if (status.length !== card.filterStatuses.length) return false;
      return card.filterStatuses.every((s) => status.includes(s));
    });
    return matched?.key ?? null;
  })();

  useEffect(() => {
    let componentIsAlive = true;
    setLoading(true);
    setApplicationsList([]);
    (async function () {
      try {
        const response = (await dispatch(
          getAllApplications({
            page: currentPage,
            limit: rowsPerPage,
            search,
            applicationType: applicationType.toString(),
            distributorId: distributorId.toString(),
            status: status
              .toString()
              .replace('draft_send_back', 'draft')
              .replace('draft,draft', 'draft'),
            modeOfHolding: modeOfHolding.toString(),
            applicationSentBack:
              status.includes('draft_send_back') && !status.includes('draft') ? true : null,
          })
        )) as unknown as GetAllApplicantionsResponseBody;
        const { applications, pages, total } = response || {};
        if (!componentIsAlive) {
          return;
        }
        setApplicationsList(applications);
        setNoPages(pages);
        setTotalApplications(total || 0);
        setLoading(false);
      } catch (e) {
        console.error((e as Error).message);
        setLoading(false);
      }
    })();
    return () => {
      componentIsAlive = false;
    };
  }, [currentPage, rowsPerPage, debounceSearchString, filters]);

  useEffect(() => {
    let componentIsAlive = true;
    (async function () {
      try {
        const stamPaper = (await dispatch(
          getConsolidatedStampPaperCount()
        )) as unknown as StampPapersType;
        const { series } = stamPaper || {};
        if (!componentIsAlive) {
          return;
        }
        setStampCount(series);
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
    return () => {
      componentIsAlive = false;
    };
  }, []);

  useEffect(() => {
    let componentIsAlive = true;
    (async function () {
      try {
        const data = (await dispatch(
          getOnboardingDashboard()
        )) as unknown as OnboardingDashboardResponse;
        if (!componentIsAlive) {
          return;
        }
        const getStageCount = (stage: string) =>
          data?.pipelineStatus?.find((item) => item.stage === stage)?.count || 0;
        setStatusCounts({
          draft: getStageCount('draft'),
          pending:
            getStageCount('review') +
            getStageCount('sent_to_investor') +
            getStageCount('sent_to_im') +
            getStageCount('sent_to_trustee'),
          completed: data?.applicationStatus?.completed?.completedCount || 0,
          expired: getStageCount('expired') + getStageCount('rejected'),
        });
      } catch (e) {
        console.error((e as Error).message);
      }
    })();
    return () => {
      componentIsAlive = false;
    };
  }, []);

  const handleStatusCardClick = (card: StatusCardConfig) => {
    const isSameFilter =
      status.length === card.filterStatuses.length &&
      card.filterStatuses.every((s) => status.includes(s));
    setPage(1);
    setFilters({
      ...filters,
      status: isSameFilter ? [] : [...card.filterStatuses],
    });
  };

  const handlePageChange = (event: ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  const handleFiltersAnchorEl = async () => {
    try {
      setFiltersAnchorEl(true);
      setDistributorLoading(true);
      const distributorList = (await dispatch(
        getDistributorsListForFilters()
      )) as unknown as Distributor[];
      setDistributors(distributorList);
      setDistributorLoading(false);
    } catch (e) {
      console.error((e as Error).message);
      setDistributorLoading(false);
    }
  };

  const handleFiltersAnchorElClose = () => {
    setFiltersAnchorEl(false);
  };

  const filterOptions = (): JSX.Element => {
    const badgeCount = ['applicationType', 'modeOfHolding', 'status', 'distributorId'].filter(
      (filterKey) => (filters[filterKey] as string[]).length
    ).length;
    const filterAriaLabel =
      badgeCount > 0
        ? `Filters, ${badgeCount} filter${badgeCount === 1 ? '' : 's'} applied`
        : 'Filters';
    return (
      <>
        <Button
          id="filter-icon-button"
          aria-label={filterAriaLabel}
          aria-controls="filter-menu"
          aria-haspopup="true"
          aria-expanded={filtersAnchorEl ? 'true' : undefined}
          onClick={handleFiltersAnchorEl}
          startIcon={
            <Badge
              badgeContent={badgeCount}
              color="info"
              sx={{ '& .MuiBadge-badge': { fontSize: 10 } }}>
              <FilterAltOutlinedIcon sx={{ fontSize: 24, color: '#6B7280' }} aria-hidden="true" />
            </Badge>
          }
          sx={{
            minWidth: 'unset',
            p: 1,
            px: 1.5,
            color: '#6B7280',
            fontFamily: 'Inter, sans-serif',
            fontWeight: 500,
            fontSize: 16,
            lineHeight: 1,
            letterSpacing: 0,
            textTransform: 'none',
            background: 'transparent',
            boxShadow: 'none',
            '&:hover': {
              background: 'transparent',
              color: '#6B7280',
            },
            '&.Mui-focusVisible, &:focus-visible': {
              outline: '3px solid #2057A6',
              outlineOffset: '2px',
            },
            '& .MuiButton-startIcon': {
              mr: 1,
            },
          }}>
          Filters
        </Button>
        {filtersAnchorEl && (
          <FilterDropdown
            filters={filters}
            onFiltersChange={(value) => {
              setPage(1);
              setFilters(value);
            }}
            anchorEl={filtersAnchorEl}
            handleClose={handleFiltersAnchorElClose}
            distributors={distributors}
            loader={distributorLoading}
          />
        )}
      </>
    );
  };

  return (
    <CommonLayout>
      <>
        <Box>
          <Typography
            component="h1"
            sx={{
              fontFamily: 'Poppins, sans-serif',
              fontSize: 18,
              fontWeight: 500,
              mb: { xs: 2, md: 4 },
              p: { xs: '5px 15px', md: '' },
              bgcolor: '#e5f1f8',
              borderRadius: '10px',
            }}>
            All Applications
          </Typography>
          {[USER_ROLES.AMC_ADMIN, USER_ROLES.RM, USER_ROLES.SUBDISTRIBUTOR].includes(role) && (
            <Box
              sx={{
                bgcolor: 'white',
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
                borderRadius: '10px',
                width: 'unset',
              }}
              mb={2}>
              <Box pb={3}>
                <Grid container sx={{ pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
                  <SubHeading
                    as="h2"
                    sx={{
                      display: 'flex',
                      mb: 0,
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}>
                    Stamp Papers Information
                  </SubHeading>
                  <Box
                    component="ul"
                    aria-label="Stamp Papers Information"
                    sx={{
                      listStyle: 'none',
                      p: 0,
                      m: 0,
                      width: '100%',
                    }}>
                    {stampCount.map((action, index) => (
                      <Grid
                        key={index}
                        component="li"
                        container
                        direction="row"
                        justifyContent="space-between"
                        sx={{ pl: { xs: 0, sm: 10 }, pr: { xs: 0, sm: 10 } }}
                        alignItems="center"
                        pt={3}>
                        {/* <Typography
                        key={index}
                        sx={{
                          fontSize: 18,
                          fontWeight: 600,
                          color: 'text.secondary',
                        }}>
                        Serial Number: {action.seriesNumber}
                      </Typography> */}
                        <Grid item xs={12} sm={4} md={4}>
                          <Typography
                            sx={{
                              fontSize: 18,
                              fontWeight: 600,
                              color: 'text.secondary',
                            }}>
                            Series Number: {action.seriesNumber}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                          <Typography
                            sx={{
                              fontSize: 18,
                              fontWeight: 600,
                              color: 'text.secondary',
                            }}>
                            Denomination: {action.denomination}
                          </Typography>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                          <Typography
                            sx={{
                              fontSize: 18,
                              fontWeight: 600,
                              color: 'text.secondary',
                              '&.Draft .MuiTypography-root': {
                                color: 'status.draft',
                              },
                              '&.Completed .MuiTypography-root': {
                                fontWeight: 600,
                                color: 'status.completed',
                              },
                              '&.Rejected .MuiTypography-root': {
                                color: '#BD2932',
                                fontWeight: 500,
                              },
                            }}>
                            Unused Stamp Count: {action.totalUnused}
                            <Typography
                              component="span"
                              sx={{
                                color: 'status.approved',
                                fontSize: '16px',
                                letterSpacing: '0.4px',
                                ml: 0.5,
                              }}></Typography>
                          </Typography>
                        </Grid>
                      </Grid>
                    ))}
                  </Box>
                </Grid>
              </Box>
            </Box>
          )}
          <ApplicationStatusCards
            counts={statusCounts}
            activeKey={activeStatusCardKey}
            onCardClick={handleStatusCardClick}
          />
          <Grid
            container
            sx={{
              p: '20px 30px',
              pb: 0,
              justifyContent: 'space-between',
              alignItems: 'flex-end',
              bgcolor: 'common.white',
              mb: 1.5,
            }}>
            <Grid item container sx={{ width: 'unset', alignItems: 'flex-end', gap: 2, pb: 3 }}>
              <Grid item>
                <FormControl
                  variant="standard"
                  fullWidth
                  sx={{ display: 'flex', flexDirection: 'column' }}>
                  <InputLabel
                    shrink // FIX: Keeps label visible above the text when focused/filled to prevent overlap
                    htmlFor="input-with-icon-adornment"
                    sx={{
                      position: 'relative', // FIX: Forces correct stacking context without overlapping the input line
                      transform: 'none', // FIX: Prevents standard jumping animations
                      fontSize: 14,
                      fontWeight: 500,
                      '&.Mui-focused': { color: 'text.primary' },
                    }}>
                    Search Application
                  </InputLabel>
                  <LiveRegion message={searchResultsMessage} />
                  <Input
                    id="input-with-icon-adornment"
                    value={search}
                    onChange={({ target: { value } }) => {
                      setPage(1);
                      setSearch(value);
                    }}
                    /* FIX: Targets the exact interactive leaf node to ensure strict WCAG 2.4.7 focus compliance */
                    sx={{
                      mt: 1,
                      '&.Mui-focused': {
                        outline: '3px solid #2057A6 !important',
                        outlineOffset: '2px !important',
                        borderRadius: '4px !important',
                      },

                      '& .MuiInputBase-input:focus': {
                        outline: '2px solid transparent !important',
                        boxShadow: 'none !important',
                      },
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        {/* FIX: Removed the interactive IconButton since the onChange handler updates dynamically. 
            Keeping a button here tricks screen readers into thinking they need to press "Enter" to submit. */}
                        <SearchSharpIcon sx={{ color: 'primary.main', mr: 1 }} aria-hidden="true" />
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Grid>
              {/* <Grid item sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.5 }}> */}
              {/* <Typography sx={{ fontSize: 14, fontWeight: 600, color: 'primary.main', pr: 1 }}>
                Filters :
              </Typography> 
               <Stack direction="row" gap={1} flexWrap="wrap">
                <Chip
                  label="Single"
                  size="small"
                  onDelete={() => console.log('chip deleted')}
                  sx={{
                    bgcolor: 'rgba(41, 49, 57, 0.05)',
                    //  '& .MuiChip-label': { lineHeight: 1 }
                  }}
                />
              </Stack> */}
              {/* </Grid> */}
            </Grid>
            <Grid item container sx={{ width: 'unset', alignItems: 'center', gap: 2, pb: 3 }}>
              <Grid item sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Button
                  variant="contained"
                  role="link"
                  aria-label="Add New Applicant"
                  startIcon={<AddIcon sx={{ fontSize: 18 }} />}
                  sx={{
                    bgcolor: 'primary.main',
                    color: '#FFFFFF',
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 500,
                    fontSize: 14,
                    lineHeight: '20px',
                    letterSpacing: '0.1996px',
                    textTransform: 'none',
                    borderRadius: '8px',
                    px: 2,
                    py: 1,
                    boxShadow: 'none',
                    '&:hover': {
                      bgcolor: 'primary.dark',
                      boxShadow: 'none',
                    },
                    '&.Mui-focusVisible, &:focus-visible': {
                      outline: '3px solid #2057A6',
                      outlineOffset: '2px',
                    },
                    '& .MuiButton-startIcon': {
                      mr: 0.75,
                    },
                  }}
                  onClick={() => history.push('/onboarding')}>
                  Add New Applicant
                </Button>
                {filterOptions()}
              </Grid>
              <Grid item>{/* <FilterMenu /> */}</Grid>
            </Grid>
          </Grid>
          <Box
            sx={{
              bgcolor: 'common.white',
              borderRadius: 3,
              border: '1px solid #E8ECF0',
              p: { xs: 2, sm: 2.5 },
              fontFamily: 'Roboto, sans-serif',
            }}>
            <DashboardAndApplicationsList
              isLoading={isLoading}
              applicationsList={applicationsList}
              DashboardApplicationsList={true}
              boxStyles={{
                minHeight: 'unset',
                maxHeight: 'none',
                overflow: 'visible',
              }}
            />

            {!!applicationsList.length && (
              <ListPaginationBar
                pageCount={noOfPages}
                page={currentPage}
                onPageChange={handlePageChange}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(rows) => {
                  setRowsPerPage(rows);
                  setPage(1);
                }}
                total={totalApplications}
              />
            )}
          </Box>
        </Box>
      </>
    </CommonLayout>
  );
}
